export const regularExpressions = {
  IDENTIFICATION_NUMBER: /^[0-9]+$/,
  INVALID_IDENTIFICATION_NUMBERS: /^(12345678|0000000000|1111111111|1234567890)$/,
  INVALID_FOREIGN_TAX_NUMBERS: /^(000000000000000|111111111111111|1234567890)$/,
  CYRILLIC_TWO_LETTERS: /^[А-ЯЄІЇҐ]{2}$/,
  LATIN_TWO_LETTERS: /^[A-Z]{2}$/u,
  MIXED_TWO_LETTERS: /^[A-ZА-ЯҐЄІЇ]{2}$/,
  UPPER_CASE_UKRAINIAN_LETTERS: /^[АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ]{2}$/u,
  UPPER_CASE_LETTERS: /^[A-ZА-ЯҐЄІЇ\s]*$/u,
  UPPER_CASE_LATIN: /^[A-Z\s]*$/,
  UPPER_CASE_CYRILLIC: /^[А-ЯҐЄІЇ\s]*$/u,
  UPPER_CASE_LATIN_AND_DIGITS: /^[A-Z0-9\s]*$/,
  SIX_DIGITS: /^\d{6}$/,
  NINE_DIGITS: /^\d{9}$/,
  AUTHORITY_LETTERS: /^[A-Za-zА-ЯҐЄІЇа-яґєії\s.,'-]+$/,
  AUTHORITY_FOUR_DIGITS: /^\d{4}$/,
  REGISTRY_RECORD: /^\d{8}-\d{5}$/,
  REGISTRY_RECORD_GIIN: /^[A-Z0-9]{6}\.[A-Z0-9]{5}\.[A-Z0-9]{2}\.[A-Z0-9]{3}$/,
  REGISTRY_RECORD_OPTIONAL: /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\u02BC\u0027\u2019]+$|^$/,
  ONLY_TEXT: /^[A-Za-zА-Яа-яҐґЄєІіЇї\s'*-]*$/u,
  JUST_DOT: /^\d*\.?\d*$/,
  ROUNDING_NUMBER: /^-?\d+(\.\d{1,6})?$/,
  ROUNDING_NUMBER_TENTH: /^-?\d+(\.\d{1,2})?$/,
  UKR_CHARACTERS_ONLY:
    /^[А-ЯҐЄІЇа-яґєії\s''.,"""«»’()&@!#$%^*+=;:?1234567890_\/[\]{}|~`<>№−…—–−‹›„‟"'‚′″‴⁄\u0300-\u036f-]*$/,
  LATIN_CHARACTERS_ONLY:
    /^[A-Za-z0-9\s\-''.,"""«»()&@!#$%^*+=;:?1234567890_\/[\]{}|~`<>№−…—–−‹›„‟"'‚′″‴⁄\u0300-\u036f]*$/,
  APPLICATION_ID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  ISO_TIMEZONE_SUFFIX: /(Z|[+-]\d{2}:\d{2})$/i,
  DUPLICATION_NUMBER: /^(\d)\1+$/,
  INTEGER_NUMBER: /^(0|[1-9]\d*)$/,
  CYRILLIC: /[\u0400-\u04FF]/,
  LATIN: /[a-zA-Z]/,
  LATIN_NUMBERS_SYMBOLS: /^[A-Za-z0-9\s.,!?@#$%^&*()\-_=+[\]{};:'"\\/|<>`~]*$/,
  INTEGER: /^-?\d+(\.\d+)?$/,
  INVISIBLE_SPACE_REGEX: /[\s\u00A0]/,
  TRIVIAL_PATTERNS: [
    /^12345678.*$/,
    /^[a-zA-Z]+$/,
    /^abcdef.*$/,
    /^qwerty.*$/,
    /^zxcvb.*$/,
    /^(.)\1+$/,
    /^(.{4})\1+$/,
  ],
  POSTAL_CODE_DIGITS: /^\d{5}$/,
  ALLOWED_CHARS: /^[a-zA-Zа-яА-ЯіїєІЇЄ0-9\-.\s/]*$/,
  LATIN_UPPERCASE: /^[A-Z\s]+$/,
  CYRILLIC_UPPERCASE: /^[АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ\s]+$/,
  SPACE_CYRILLIC_LATIN_NUMBERS:
    /^(?!.*[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ]*[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ]*[a-zA-Z].*[а-яА-ЯёЁіІїЇєЄґҐ])(?!.*[а-яА-ЯёЁіІїЇєЄґҐ].*[a-zA-Z])[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ0-9\s!"#$№%&'«»()*+,\-./:;<=>?@[\]^_`{|}~\\]*$/,
  EIN_FORMAT: /^\d{2}-\d{7}$/,
  TIN_FORMAT: /^\d{3}-\d{2}-\d{4}$/,
  LATIN_NAME: /^[A-Za-z]+(?:[ '’`\-\][A-Za-z]+)*$/,
  LATIN_NAME_UPPERCASE: /^[A-Za-z .'-]+$/,
  FATCA_TIN_SSN: /^\d{3}-\d{2}-\d{4}$/,
  FATCA_TIN_ITIN: /^9\d{2}-\d{2}-\d{4}$/,
  FATCA_TIN_TIN: /^(\d{9}|\d{3}-\d{2}-\d{4}|\d{2}-\d{7})$/,
};
